import { Children } from 'react';
import PropTypes from 'prop-types';
import { useTranslate, useRecordContext } from 'react-admin';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover.jsx';

export const DetailsActionsPopover = ({ children }) => {
    const record = useRecordContext();
    const translate = useTranslate();
    const items = Children.toArray(children);

    if (!record || items.length === 0) {
        return null;
    }

    return (
        <CustomMorePopover record={record} buttonLabel={translate('common.options')} className='more-area-in-details' color='secondary'>
            {children}
        </CustomMorePopover>
    );
};

DetailsActionsPopover.propTypes = {
    children: PropTypes.node,
};
